import React from 'react'
import { Box, Text, Button, Link,HStack } from "@chakra-ui/react";
import {DownloadIcon} from '@chakra-ui/icons';
import './about.css'
const About = () => {
  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch('Resume.pdf').then(response => {
        response.blob().then(blob => {
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(blob);
            // Setting various property values
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = 'Gprasad_Bhat_resume.pdf';
            alink.click();
        })
    })
}
  return (
    <div id="about">
        <HStack width={'100%'} alignItems={'center'} justifyContent={'center'} fontWeight={'800'} >
              <Text fontSize={'2xl'}>About Me</Text>
         </HStack>
      <Box className='abouts' display='flex' flexDirection={'column'} alignItems='center' width={['100%', '80%', '70%']}>
        <Text fontWeight={'600'} fontSize={['20px', '20px','24px', '24px']} textAlign="center">An enthusiastic Full Stack Web developer who spent 1200+ hrs on coding and solved 100+ DSA problems with massive training on project presentation by Masai School and can fit to work in any working environment.</Text>
        <Link href='https://drive.google.com/file/d/1vA3jSj2Kl88Em48SUx5LsYbeSh0MUkEg/view?usp=share_link' target={"_blank"}><Button width='150px' margin='auto' marginTop='10px'color='black' onClick={onButtonClick}>Resume<DownloadIcon marginLeft={'15px'}/></Button></Link>
      </Box>
    </div>
  )
}

export default About